import {Crop, Perspective, UserId, blobToBase64} from '@legit.health/ui';
import * as Sentry from '@sentry/react';
import {
  processAnamnesisQuestions,
  processScoringSystems
} from '../../../utils/mapFormValuesToApiFormat';

export async function mapImageFormValuesToApiFormat(values: {
  image: {
    id: string;
    crop: Crop | null;
    file: Blob | null;
  };
  conditionId: string;
  scoringSystems: Record<string, any>;
  patientId: UserId;
  perspective?: Perspective | null;
  visitIdentifier: string | null;
  anamnesisQuestions: Record<string, string>;
}) {
  if (!values.image.crop || !values.image.file) {
    throw new Error();
  }
  let base64Image = null;
  try {
    base64Image = await blobToBase64(values.image.file);
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        crop: values.image.crop === null ? 'yes' : 'no',
        isNull: values.image.file === null ? 'yes' : 'no',
        data: 'blobToBase64 error',
        type: typeof values.image.file,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        mimeType: values.image.file instanceof File ? values.image.file.type : 'unknown',
        value:
          typeof values.image.file === 'string'
            ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              values.image.file.substring(0, 50)
            : 'some value',
        values: JSON.stringify({
          cropDimensions: values.image.crop ?? '',
          hasImage: values.image.file ? 'yes' : 'no'
        })
      }
    });
    throw new Error();
  }
  return {
    image: {
      x: values.image.crop.x,
      y: values.image.crop.y,
      width: values.image.crop.width,
      height: values.image.crop.height,
      image: base64Image
    },
    patient: values.patientId,
    scoringSystems: processScoringSystems(values.scoringSystems),
    condition: values.conditionId,
    perspective: values.perspective,
    visitIdentifier: values.visitIdentifier,
    anamnesisQuestions: processAnamnesisQuestions(values.anamnesisQuestions)
  };
}

export async function mapVideoFormValuesToApiFormat(values: {
  video?: Blob | null;
  conditionId: string;
  scoringSystems: Record<string, any>;
  patientId: UserId;
  perspective?: Perspective | null;
  visitIdentifier: string | null;
  anamnesisQuestions: Record<string, string>;
}) {
  if (!values.video) {
    throw new Error();
  }
  const base64Video = await blobToBase64(values.video);
  return {
    video: base64Video,
    patient: values.patientId,
    scoringSystems: processScoringSystems(values.scoringSystems),
    condition: values.conditionId,
    perspective: values.perspective,
    visitIdentifier: values.visitIdentifier,
    anamnesisQuestions: processAnamnesisQuestions(values.anamnesisQuestions)
  };
}
